export const TABLET_BREAKPPOINT = 1024;
export const MEDIUM_MOBILE_BREAKPOINT = 600;
export const MOBILE_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1366;
export const CONTAINER_BREAKPOINT = 1295;
